"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBigIntAsc = void 0;
function sortBigIntAsc(a, b) {
    return (a < b ? -1 : a > b ? 1 : 0);
}
exports.sortBigIntAsc = sortBigIntAsc;
